import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// A dark code box with a copy-to-clipboard button (for embed/tracking snippets).
export const CopyBox = ({ value, label, testid = "copy-box", maxH = "max-h-60" }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value || "");
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed — select and copy manually");
    }
  };
  return (
    <div>
      {label && <Label className="text-xs mb-1.5 block text-muted-foreground">{label}</Label>}
      <div className="relative">
        <pre className={`text-[11px] leading-relaxed bg-[#0F2230] text-[#D7E3EC] rounded-lg p-3 pr-12 overflow-auto mmm-scroll ${maxH} whitespace-pre-wrap break-words`} data-testid={`${testid}-content`}>{value}</pre>
        <Button size="sm" variant="outline" onClick={copy} className="absolute top-2 right-2 h-8" data-testid={testid}>
          {copied ? <Check size={14} /> : <Copy size={14} />}
        </Button>
      </div>
    </div>
  );
};
